<template>
    <div v-if="!userFeatures.hasOwnProperty('confirmed-address')" class="row pt-2">
        <div class="col">
            <div class="sau-bx bx-pad">
                <div class="row d-flex">
                    <div class="col-lg-3">
                        <img src="/img/apiro.gif" class="img-fluid"/>
                    </div>
                    <div class="col-lg-9 align-self-center p-2 bd-highlight">
                        <div class="row">
                            <div class="col">
                                <h2>Welcome to Servers Australia</h2>
                            </div>
                        </div>
                        <div class="row py-2">
                            <div class="col">
                                <div class="sau-bx p-6">
                                    <div class="row">
                                        <div class="col-lg-8 align-self-center">
                                            <h4>{{userHasVerified.title}}</h4>
                                            <p class="sau-font sm">{{userHasVerified.msg}}</p>
                                        </div>
                                        <div class="col-lg-4 align-self-center text-lg-right">
                                            <a :href="'/account/'" class="btn btn-success btn-sm text-center">Verify your account</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import UserProfileUtility from '@js/components/utilities/Profile';
import WelcomeVideo from '@js/components/utilities/WelcomeVideo';
export default {
    components:{
        'sau-utility-profile': UserProfileUtility,
        'sau-utility-welcome-video': WelcomeVideo,
    },
    mounted(){

    },
    computed: {
        ...mapState([
            'userHasVerified'
        ]),
    }
}
</script>
